import React, { useState, useEffect, useRef } from 'react';
import ReactLoading from 'react-loading';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import classNames from 'classnames'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { SessionService } from '../service/SessionService';
import { ChargementAdmissibleService } from '../service/ChargementAdmissibleService';

function ChargerAdmissibles() {

    const [session, setSession] = useState(null)
    const [file, setFile] = useState(null);
    const [nameFile, setNameFile] = useState('');
    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [success, setSuccess] = useState(false)

    const sessionService = new SessionService()
    const chargementAdmissibleService = new ChargementAdmissibleService()

    const data = localStorage.getItem('user')
    const user = JSON.parse(data)
    //let role = user.roles[0]

    useEffect(() => {
      console.log(user)
      sessionService.getSessionDirection(user.idDirection).then(data => {
                
        let sessionOuverte = data.filter(session => {
            if(session.statutSession === "OUVERT") return session
        })
        //console.log("Session ouverte :", sessionOuverte[0])
        setSession(sessionOuverte[0]);
      })
      .catch(error => {
        console.log(error)
      })
        
    }, []);

    const saveImportFichier = async () => {
        setSubmitted(true)
        if (!file) return;

    try {
        const base64File = await onFileDecodeBase64(file);

        const payload = {
            nomFichier: file.name,
            fichier: base64File,
            idSession: session.idSessionCenou
        };
        //console.log("Payload à envoyer :", payload);
        setLoading(true)
        await chargementAdmissibleService.chargementFichier(payload)
        setSuccess(true)
        setLoading(false)
    }
    catch (error) {
      console.error("Erreur upload :", error);
      setSuccess(false)
      setLoading(false)

    }
}

    const onFileDecodeBase64 = (file) => {
        
        if(file) {
            let extension = file.name.split(".").pop();
            let ext = extension.toUpperCase();

            if (ext === "CSV") {
                setNameFile(file.name)
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        // Supprimer le préfixe "data:...;base64,"
                        const base64 = reader.result.split(",")[1];
                        resolve(base64);
                    };
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(file);
                });
            }
        }
  
    }

    const handleChangeFile = (e) => {
        setFile(e.target.files[0]);
    };

    const loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )

  return (
    <div>
        <div className="card p-lg-10" style={{ marginLeft: "10%", marginTop: "5%" }}>
            <div className="p-grid p-lg-12" style={{ marginTop: "3%" }}>
                <div className="p-lg-12">
                    <h3 style={{textDecoration: "underline",textAlign: "center",}}>
                        <a href="/assets/layout/fichiers/cenou-canevas_admissibles.csv" target="_blank">
                            Cliquer ici pour télécharger le canevas des admissibles
                        </a>
                    </h3>
                </div>
            </div>
                <div className="p-lg-12" style={{ marginTop: 10 }}>
                    <div className="p-lg-12 p-grid" style={{ marginTop: 10, marginLeft: "10%" }}>
                            <div className="p-lg-12 p-grid" style={{ marginLeft: "0%" }}>
                                <div className="p-lg-4" style={{ marginTop: -20 }}>
                                    <input type="file" style={{ marginLeft: "0%" }}
                                        onChange={(e) => {
                                            handleChangeFile(e);
                                        }}
                                    />
                                </div>
                                {loading ? (
                                    <div className="p-lg-2">
                                        {loadingSpinner(
                                            "spin",
                                            "black"
                                        )}
                                    </div>
                                ) : (
                                    <div className="p-lg-2">
                                        {submitted &&
                                            success && (
                                                <span
                                                    style={{ color: "green" }}
                                                >
                                                    Chargement réussi !
                                                </span>
                                            )}
                                        {submitted &&
                                            !success && (
                                                <span style={{ color: "red" }}>
                                                    Echec de chargement !
                                                </span>
                                            )}
                                    </div>
                                )}
                                <div
                                    className="p-lg-4"
                                    style={{ marginTop: -20 }}
                                >
                                    <Button
                                        style={{ marginLeft: "0%" }}
                                        label="Valider le chargement"
                                        onClick={saveImportFichier}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  )
}

export default ChargerAdmissibles